import { CSSObject } from "styled-components";

interface MoreActionsMenuStyles {
  navItem: CSSObject;
}

const useMoreActionsMenuStyles = (): MoreActionsMenuStyles => {
  return {
      navItem: {
          cursor: "pointer",
          marginBottom:".5em"
      },
  };
};

export default useMoreActionsMenuStyles;
